import { RANK } from "@/mocks/gossip";

export default function Rank() {
  return (
    <section id="rank" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-700 uppercase">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              Weekly
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">本周高能榜单</h2>
            <p className="mt-3 text-sm text-foreground-700">根据热度与讨论度，汇总本周传播力最强的名场面 TOP。</p>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-900 whitespace-nowrap md:inline-flex">
            <i className="ri-calendar-check-line" aria-hidden="true"></i>
            更新至 {RANK[0] ? "2026.09.07" : ""}
          </span>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
          {RANK.map((r) => (
            <li
              key={r.id}
              className="group flex items-center gap-5 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-200"
            >
              <span className="font-heading text-5xl font-black leading-none text-primary-100 group-hover:text-primary-200">
                {r.rank}
              </span>
              <img src={r.img} alt="" className="hidden h-20 w-20 shrink-0 rounded-xl object-cover sm:block" />
              <div className="min-w-0 flex-1">
                <span className="text-xs font-semibold text-accent-700">{r.type}</span>
                <h3 className="mt-1 truncate font-heading text-base font-bold text-foreground-950">{r.title}</h3>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                    {r.heat} 热度
                  </span>
                  <span className="flex items-center gap-1 font-semibold text-accent-600 whitespace-nowrap">
                    <i className="ri-arrow-up-line" aria-hidden="true"></i>
                    {r.delta}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}